import uberEatsLogo from '../assets/svg/uber-eats.svg';
import justoLogo from '../assets/svg/logo-justo.svg';
import peyaLogo from '../assets/svg/pedidosya.svg';
import rappiLogo from '../assets/svg/rappi.png';

const logos = {
    UBEREATS: uberEatsLogo,
    JUSTO: justoLogo,
    'PEDIDOS YA': peyaLogo,
    RAPPI: rappiLogo,
};

export const getLogo = (aggregatorName) =>
    logos[aggregatorName?.toUpperCase()] ?? null;
